import './Success.scss';

const Success = ({
    t,
    handleResubscribe,
    isResubscribing,
    resubscribeError
}) => {
    if (resubscribeError) {
        return (
            <div className="unsubscribe__error__container">
                <p className="unsubscribe__confirmed__error">
                    {resubscribeError}
                </p>
            </div>
        );
    }

    return (
        <>
            <h2 className="unsubscribe__confirmed__title">{t.title}</h2>

            <p className="unsubscribe__confirmed__subtitle">
                {t.message}
            </p>

            <p className="unsubscribe__confirmed__text">
                {t.backText}{' '}

                <button
                    onClick={handleResubscribe}
                    disabled={isResubscribing}
                    className="unsubscribed__confirmed__link"
                >
                    {isResubscribing ? '...' : t.backLink}
                </button>
            </p>
        </>
    );
};

export default Success;